module.exports = {
    website1: process.env.ASSETS_VERSION_NICKTESTSTORE22_MYSHOPIFY_COM,
    website2: process.env.ASSETS_VERSION_WWW_NIKE_COM,
    bloomnation: process.env.ASSETS_VERSION_BLOOMNATION,
    PIZZA_STORES: process.env.ASSETS_VERSION_PIZZA_STORES,
};
